import { render } from "./welcome.vue?vue&type=template&id=26acb2d0"
import script from "./welcome.vue?vue&type=script&lang=js"
export * from "./welcome.vue?vue&type=script&lang=js"

import "./welcome.vue?vue&type=style&index=0&id=26acb2d0&lang=sass"
script.render = render

export default script